export default __webpack_public_path__ + "static/media/login.40821003.webp";